<template>
  <div class="remote-control-box">
    <div class="nav-top flex-space-between">
      <div class="txt">
        <i class="iconfont icon-xiaofangzhuji" style="margin-right: 10px"></i
        >{{ deviceName }}远程控制台
      </div>
      <div>
        <Button @click="singleRefresh" type="primary" style="margin-right: 8px"
          >刷新</Button
        >
        <i class="iconfont icon-fork" @click="closeModel"></i>
      </div>
    </div>
    <div class="flex-space-between">
      <div class="control-left">
        <div class="control-left-top" ref="controlLeft">
          <VideoMonitor
            :videoW="videoW"
            :videoH="videoH"
            :moduleId="moduleId"
          />
        </div>
        <div class="control-left-bottom">
          <PoliceLog
            :orgId="orgId"
            :moduleId="moduleId"
            :intervalIndex="intervalIndex"
          />
        </div>
      </div>
      <div class="control-content">
        <div class="control-content-top">
          <div class="control-content-title">
            <span class="title">控制台</span>
            <span class="sub-tit sub-title">多线盘</span>
          </div>
          <!-- 使用卡片类型的 Tabs，支持关闭操作 -->
          <Tabs
            type="card"
            closable
            @on-click="tabTopChange"
            :before-remove="beforeTopRemove"
            :value="tabsTopValue.toString()"
          >
            <!-- 动态生成 Tab 项 -->
            <TabPane
              v-for="(item, index) in tabsTop"
              :key="item.id"
              :label="item.name"
              :name="index.toString()"
            >
              <div class="control-content-content">
                <div class="control-content-search">
                  <Row :gutter="16">
                    <Col span="4">
                      <Input
                        v-model="serchTopForm.name"
                        placeholder="搜索点位名称"
                      ></Input>
                    </Col>
                    <Col span="4">
                      <Select
                        clearable
                        v-model="serchTopForm.buildingId"
                        placeholder="所属建筑"
                      >
                        <Option
                          v-for="(item, index) in systemForm"
                          :value="item.id"
                          :key="index"
                          >{{ item.name }}</Option
                        >
                      </Select>
                    </Col>
                    <Col span="4">
                      <Select
                        clearable
                        v-model="serchTopForm.partTypeCode"
                        placeholder="点位类型"
                      >
                        <Option
                          v-for="(item, index) in deviceTypeCode"
                          :value="item.value"
                          :key="index"
                          >{{ item.name }}
                        </Option>
                      </Select>
                    </Col>
                    <Col span="3">
                      <Button @click="getTopSearch" type="primary">搜索</Button>
                    </Col>
                    <Col
                      span="4"
                      offset="5"
                      style="
                        line-height: 32px;
                        font-size: 14px;
                        text-align: right;
                      "
                    >
                      <a
                        v-show="!editTopState"
                        @click="editTopState = !editTopState"
                      >
                        <i
                          class="iconfont icon-shezhi"
                          style="margin-right: 5px"
                        ></i
                        >编辑模式</a
                      >
                      <a
                        v-show="editTopState"
                        @click="editTopState = !editTopState"
                      >
                        <i
                          class="iconfont icon-fanhui"
                          style="margin-right: 5px"
                        ></i
                        >返回</a
                      >
                    </Col>
                  </Row>
                </div>
                <div class="control-content-list">
                  <ul class="flex-flex-start-wrap">
                    <li
                      class="item-li"
                      v-for="(item, index) in controlContentTopTabObj"
                      :key="index"
                      :style="{
                        marginBottom: isLastRow(index, 8, 5) ? '0px' : '10px',
                      }"
                    >
                      <h3>
                        <span
                          class="text1-hidden"
                          v-show="!editTopState"
                          :title="item.name"
                          >{{ item.name }}</span
                        ><input
                          type="text"
                          v-model="item.name"
                          v-show="editTopState"
                          @blur="putTopBottomTabObj(item.id, item.name)"
                        />
                        <Poptip
                          v-show="editTopState"
                          confirm
                          :placement="
                            (index + 1) % 5 > 0 ? 'top' : 'left-start'
                          "
                          title="请确认是否解绑点位？"
                          @on-ok="delChange(item, '1')"
                        >
                          <i class="iconfont icon-shanchu3"></i>
                        </Poptip>
                      </h3>
                      <div class="control-content-list-state flex-flex-start">
                        <div>
                          <i
                            :class="
                              item.workState.qd == 11
                                ? 'active'
                                : item.workState.qd == 1
                                ? 'active-c'
                                : ''
                            "
                          ></i
                          >启动
                        </div>
                        <div style="margin-left: 15px">
                          <i :class="{ 'active-c': item.workState.fk == 1 }"></i
                          >反馈
                        </div>
                      </div>
                      <div class="control-content-list-btn flex-flex-end">
                        <Poptip
                          confirm
                          title="请确认是否启动点位？"
                          @on-ok="startStopTopChange(item, 1)"
                        >
                          <Button type="primary">启动</Button>
                        </Poptip>
                        <Poptip
                          confirm
                          title="请确认是否停止点位？"
                          @on-ok="startStopTopChange(item, 0)"
                        >
                          <Button type="primary">停止</Button>
                        </Poptip>
                      </div>
                    </li>
                    <li
                      class="control-content-list-add"
                      @click="addPointChange('1')"
                      style="margin-bottom: 0"
                    >
                      <i class="iconfont icon-xinjian"></i><br />
                      新建点位
                    </li>
                  </ul>
                </div>
              </div>
            </TabPane>
            <!-- 在 Tabs 组件的额外位置添加一个增加按钮 -->
            <Button
              @click="handleTabsAdd('1')"
              size="small"
              slot="extra"
              style="
                background-color: rgba(0, 0, 0, 0);
                border-color: rgba(116, 217, 255, 0.5);
              "
            >
              <Icon type="md-add" style="color: #74d9ff"
            /></Button>
          </Tabs>
        </div>
        <div class="control-content-top control-content-bottom">
          <div class="control-content-title">
            <span class="title">控制台</span>
            <span class="sub-tit sub-title">总线盘</span>
          </div>
          <!-- 使用卡片类型的 Tabs，支持关闭操作 -->
          <Tabs
            type="card"
            closable
            @on-tab-remove="handleTabBottomRemove"
            @on-click="tabBottomChange"
            :before-remove="beforeBottomRemove"
            :value="tabsBottomValue.toString()"
          >
            <!-- 动态生成 Tab 项 -->
            <TabPane
              v-for="(item, index) in tabsBottom"
              :key="item.id"
              :label="item.name"
              :name="index.toString()"
            >
              <div class="control-content-content">
                <div class="control-content-search">
                  <Row :gutter="16">
                    <Col span="4">
                      <Input
                        v-model="serchBottomForm.name"
                        placeholder="搜索点位名称"
                      ></Input>
                    </Col>
                    <Col span="4">
                      <Select
                        clearable
                        v-model="serchBottomForm.buildingId"
                        placeholder="所属建筑"
                      >
                        <Option
                          v-for="(item, index) in systemForm"
                          :value="item.id"
                          :key="index"
                          >{{ item.name }}</Option
                        >
                      </Select>
                    </Col>
                    <Col span="4">
                      <Select
                        clearable
                        v-model="serchBottomForm.partTypeCode"
                        placeholder="点位类型"
                      >
                        <Option
                          v-for="(item, index) in deviceTypeCode"
                          :value="item.value"
                          :key="index"
                          >{{ item.name }}
                        </Option>
                      </Select>
                    </Col>
                    <Col span="3">
                      <Button @click="getbottomSearch" type="primary"
                        >搜索</Button
                      >
                    </Col>
                    <Col
                      span="4"
                      offset="5"
                      style="
                        line-height: 32px;
                        font-size: 14px;
                        text-align: right;
                      "
                    >
                      <a
                        v-show="!editBottomState"
                        @click="editBottomState = !editBottomState"
                      >
                        <i
                          class="iconfont icon-shezhi"
                          style="margin-right: 5px"
                        ></i
                        >编辑模式</a
                      >
                      <a
                        v-show="editBottomState"
                        @click="editBottomState = !editBottomState"
                      >
                        <i
                          class="iconfont icon-fanhui"
                          style="margin-right: 5px"
                        ></i
                        >返回</a
                      >
                    </Col>
                  </Row>
                </div>
                <div class="control-content-list">
                  <ul class="flex-flex-start-wrap">
                    <li
                      class="item-li"
                      v-for="(item, index) in controlContentBottomTabObj"
                      :key="index"
                      :style="{
                        marginBottom: isLastRow(index, 8, 5) ? '0px' : '10px',
                      }"
                    >
                      <h3>
                        <span
                          class="text1-hidden"
                          v-show="!editBottomState"
                          :title="item.name"
                          >{{ item.name }}</span
                        ><input
                          type="text"
                          v-model="item.name"
                          v-show="editBottomState"
                          @blur="putTopBottomTabObj(item.id, item.name)"
                        />
                        <Poptip
                          v-show="editBottomState"
                          confirm
                          :placement="
                            (index + 1) % 5 > 0 ? 'top' : 'left-start'
                          "
                          title="请确认是否解绑点位？"
                          @on-ok="delChange(item, '0')"
                        >
                          <i class="iconfont icon-shanchu3"></i>
                        </Poptip>
                      </h3>
                      <div
                        class="control-content-list-state-btn flex-space-between"
                      >
                        <div class="control-content-list-state">
                          <div>
                            <i
                              :class="
                                item.workState.qd == 11
                                  ? 'active'
                                  : item.workState.qd == 1
                                  ? 'active-c'
                                  : ''
                              "
                            ></i
                            >启动
                          </div>
                          <div>
                            <i
                              :class="{ 'active-c': item.workState.fk == 1 }"
                            ></i
                            >反馈
                          </div>
                        </div>
                        <div class="control-content-list-btn">
                          <Poptip
                            confirm
                            title="请确认是否启动点位？"
                            @on-ok="startStopTopChange(item, 1)"
                            v-if="
                              item.workState.qd == '0' ||
                              item.workState.qd == null
                            "
                          >
                            <Button type="primary">启动</Button>
                          </Poptip>
                          <Poptip
                            confirm
                            title="请确认是否停止点位？"
                            @on-ok="startStopTopChange(item, 0)"
                            v-else
                          >
                            <Button type="primary">停止</Button>
                          </Poptip>
                        </div>
                      </div>
                    </li>
                    <li
                      class="control-content-list-add"
                      @click="addPointChange('0')"
                      style="margin-bottom: 0px"
                    >
                      <i class="iconfont icon-xinjian"></i><br />
                      新建点位
                    </li>
                  </ul>
                </div>
              </div>
            </TabPane>
            <!-- 在 Tabs 组件的额外位置添加一个增加按钮 -->
            <Button
              @click="handleTabsAdd('0')"
              size="small"
              slot="extra"
              style="
                background-color: rgba(0, 0, 0, 0);
                border-color: rgba(116, 217, 255, 0.5);
              "
            >
              <Icon type="md-add" style="color: #74d9ff"
            /></Button>
          </Tabs>
        </div>
      </div>
      <div class="control-right">
        <div class="control-right-top">
          <div class="control-right-title">
            <span class="title">主机状态</span>
          </div>
          <div class="control-right-top-top flex-space-between-wrap">
            <div class="control-right-top-item">
              <span
                ><i :class="{ 'color-red': hostStateObj.hj == 1 }"></i
                >火警</span
              >
            </div>
            <div class="control-right-top-item">
              <span
                ><i :class="{ 'color-red': hostStateObj.jg == 1 }"></i
                >监管</span
              >
            </div>
            <div class="control-right-top-item">
              <span
                ><i :class="{ 'color-red': hostStateObj.fk == 1 }"></i
                >反馈</span
              >
            </div>
            <div class="control-right-top-item">
              <span
                ><i
                  :class="
                    hostStateObj.zdi == 1
                      ? 'color-yellow'
                      : hostStateObj.zdi == 0
                      ? 'color-green'
                      : ''
                  "
                ></i
                >主电</span
              >
            </div>
            <div class="control-right-top-item">
              <span
                ><i :class="{ 'color-red': hostStateObj.qd == 1 }"></i
                >启动</span
              >
            </div>
            <div class="control-right-top-item">
              <span
                ><i :class="{ 'color-yellow': hostStateObj.gz == 1 }"></i
                >故障</span
              >
            </div>
            <div class="control-right-top-item">
              <span
                ><i :class="{ 'color-orange': hostStateObj.pb == 1 }"></i
                >屏蔽</span
              >
            </div>
            <div class="control-right-top-item">
              <span
                ><i
                  :class="
                    hostStateObj.bdi == 1
                      ? 'color-yellow'
                      : hostStateObj.bdi == 0
                      ? 'color-green'
                      : ''
                  "
                ></i
                >备电</span
              >
            </div>
            <div class="control-right-top-item">
              <span
                ><i
                  :class="
                    hostStateObj.sdo == 1
                      ? 'color-green'
                      : hostStateObj.sdo == 0
                      ? 'color-red'
                      : ''
                  "
                  style="text-align: center; line-height: 12px"
                  ><label
                    class="iconfont"
                    :class="hostStateObj.sdo == 1 ? 'icon-duihao' : 'icon-fork'"
                    style="color: #fff; font-size: 12px"
                  ></label></i
                >手动</span
              >
            </div>
            <div class="control-right-top-item">
              <span
                ><i
                  :class="
                    hostStateObj.zdo == 1
                      ? 'color-green'
                      : hostStateObj.zdo == 0
                      ? 'color-red'
                      : ''
                  "
                  style="text-align: center; line-height: 12px"
                  ><label
                    class="iconfont"
                    :class="hostStateObj.zdo == 1 ? 'icon-duihao' : 'icon-fork'"
                    style="color: #fff; font-size: 12px"
                  ></label></i
                >自动</span
              >
            </div>
            <div class="control-right-top-item">
              <span
                ><i :class="{ 'color-red': hostStateObj.xy == 1 }"></i
                >消音</span
              >
            </div>
            <div class="control-right-top-item">
              <!-- <span
                ><i
                  :class="
                    hostStateObj.ps == 1
                      ? 'color-green'
                      : hostStateObj.ps == 0
                      ? 'color-red'
                      : ''
                  "
                  style="text-align: center; line-height: 12px"
                  ><label
                    class="iconfont"
                    :class="hostStateObj.ps == 1 ? 'icon-duihao' : 'icon-fork'"
                    style="color: #fff; font-size: 12px"
                  ></label></i
                >喷洒</span
              > -->
            </div>
          </div>
          <div class="control-right-top-bottom">
            <div class="control-right-top-bottom-title">
              <span style="font-size: 16px; font-weight: 600; color: #fff"
                >主机操作</span
              >
            </div>
            <div class="flex-space-between control-right-top-button">
              <Poptip
                style="width: auto"
                confirm
                title="确定当前操作吗？"
                @on-ok="masterOperations(1)"
                ok-text="确定"
                cancel-text="取消"
              >
                <Button type="error" style="padding: 5px 21.5px 6px"
                  ><i class="iconfont icon-jingyin-xiaoyin"></i>消音
                </Button>
              </Poptip>
              <Poptip
                style="width: auto"
                confirm
                title="确定当前操作吗？"
                @on-ok="masterOperations(2)"
                ok-text="确定"
                cancel-text="取消"
              >
                <Button type="warning" style="padding: 5px 21.5px 6px"
                  ><i class="iconfont icon-caozuo-fuwei"></i>复位
                </Button>
              </Poptip>
              <Poptip
                style="width: auto"
                confirm
                title="确定当前操作吗？"
                @on-ok="masterOperations(3)"
                ok-text="确定"
                cancel-text="取消"
              >
                <Button type="primary" style="padding: 5px 21.5px 6px"
                  ><i class="iconfont icon-icon_duihao-mian"></i>自检
                </Button>
              </Poptip>
            </div>
            <div class="flex-space-between control-right-top-button">
              <Poptip
                style="width: auto"
                confirm
                title="确定当前操作吗？"
                @on-ok="masterOperations(4)"
                ok-text="确定"
                cancel-text="取消"
              >
                <Button type="primary"
                :style="{
                    padding:
                      hostStateObj.sdo != 0 || hostStateObj.sdo != 1
                        ? '0 29px'
                        : '',
                  }"
                  ><i
                    class="iconfont"
                    :class="hostStateObj.sdo == 1 ? 'icon-fork' : 'icon-duihao'"
                  ></i
                  >
                  <!-- {{
                    hostStateObj.sdo == 1
                      ? "手动禁止"
                      : hostStateObj.sdo == 0
                      ? "手动允许"
                      : "手动"
                  }} -->
                      手动
                </Button>
              </Poptip>
              <Poptip
                style="width: auto"
                confirm
                title="确定当前操作吗？"
                @on-ok="masterOperations(5)"
                ok-text="确定"
                cancel-text="取消"
              >
                <Button type="primary"
                :style="{
                    padding:
                      hostStateObj.zdo != 0 || hostStateObj.zdo != 1
                        ? '0 29px'
                        : '',
                  }"
                  ><i
                    class="iconfont"
                    :class="hostStateObj.zdo == 1 ? 'icon-fork' : 'icon-duihao'"
                  ></i
                  >
                  <!-- {{
                    hostStateObj.zdo == 1
                      ? "自动禁止"
                      : hostStateObj.zdo == 0
                      ? "自动允许"
                      : "自动"
                  }} -->
                  自动
                </Button>
              </Poptip>
              <Poptip
                style="width: auto"
                confirm
                title="确定当前操作吗？"
                @on-ok="masterOperations(8)"
                ok-text="确定"
                cancel-text="取消"
              >
                <Button type="primary" style="padding: 5px 7px 6px"
                  ><i
                    class="iconfont"
                    :class="hostStateObj.ps == 1 ? 'icon-fork' : 'icon-duihao'"
                  ></i
                  >{{ hostStateObj.ps == 1 ? "喷洒禁止" : "喷洒允许" }}
                </Button>
              </Poptip>
            </div>
            <div class="flex-space-around control-right-top-button">
              <Poptip
                style="width: auto"
                confirm
                title="确定当前操作吗？"
                @on-ok="masterOperations(6)"
                ok-text="确定"
                cancel-text="取消"
                ><Button type="warning"
                  ><i class="iconfont icon-pingbi"></i>点位屏蔽
                </Button>
              </Poptip>
              <Poptip
                style="width: auto"
                confirm
                title="确定当前操作吗？"
                @on-ok="masterOperations(7)"
                ok-text="确定"
                cancel-text="取消"
                ><Button type="warning"
                  ><i class="iconfont icon-jiechupingbi"></i>解除屏蔽
                </Button>
              </Poptip>
            </div>
          </div>
        </div>
        <div class="control-right-bottom">
          <div class="control-right-bottom-title">
            <span style="font-size: 16px; font-weight: 600; color: #fff"
              >操作日志</span
            >
          </div>
          <div class="control-right-bottom-content" ref="operationLogListRef">
            <ul>
              <li v-for="(item, index) in operationLogList" :key="index">
                <p>{{ getDates(item.operateTime, "year") }}</p>
                <h4>{{ item.downValue }}</h4>
              </li>
            </ul>
            <div style="min-height: 50px; position: relative">
              <Spin
                fix
                v-if="loading"
                style="background-color: rgba(0, 0, 0, 0)"
                >加载中...</Spin
              >
            </div>
            <div v-if="noMoreData" class="no-more-data">没有更多数据了</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新建多线盘的 Modal 对话框 -->
    <Modal
      v-model="showAddModal"
      :title="contentTabType == '1' ? '新建多线盘' : '新建总线盘'"
      :closable="false"
      :mask-closable="false"
      class-name="show-add-tab"
    >
      <!-- 表单用于输入多线盘序号 -->
      <Form
        ref="addFormRef"
        :model="addForm"
        :rules="contentTabType == '1' ? addRule : addRule2"
      >
        <FormItem
          prop="tabName"
          :label="
            contentTabType == '1' ? '请输入多线盘序号' : '请输入总线盘序号'
          "
        >
          <Input
            type="text"
            v-model="addForm.tabName"
            :placeholder="
              contentTabType == '1' ? '请输入多线盘序号' : '请输入总线盘序号'
            "
          ></Input>
        </FormItem>
      </Form>
      <!-- 对话框底部的操作按钮 -->
      <div slot="footer">
        <Button
          @click="cancelAddModal"
          style="background-color: rgba(231, 231, 231, 0.2); color: #fff"
          >取消</Button
        >
        <Button
          @click="submitAddModal"
          type="primary"
          style="background-color: #0256ff"
          >确定</Button
        >
      </div>
    </Modal>
    <addpoint
      :deviceTypeCode="deviceTypeCode"
      :addPointVisible="addPointVisible"
      :activeTabId="activeTabId"
      :orgId="orgId"
      :moduleId="moduleId"
      @addPointUpdate="addPointUpdate"
    ></addpoint>
    <pointShielding
      :deviceTypeCode="deviceTypeCode"
      :pointShieldingVisible="pointShieldingVisible"
      :operationsType="operationsType"
      @pointShieldingUpdate="pointShieldingUpdate"
      @upDateRefresh="refresh"
      :orgId="orgId"
      :moduleId="moduleId"
      :controllerNum="controllerNum"
    ></pointShielding>
  </div>
</template>
<script>
import { getDate } from "@/libs/tools";
import VideoMonitor from "./components/VideoMonitor.vue";
import PoliceLog from "./components/PoliceLog.vue";
import addpoint from "./add-point.vue";
import pointShielding from "./point-shielding.vue";
import axios1 from "@/assets/js/axios1.js";
import { timers } from "jquery";
export default {
  // 定义组件的props，确保 orgId 是字符串类型
  props: {
    orgId: String | Number,
    moduleId: String | Number,
    controllerNum: String | Number,
    deviceName: String | Number,
  },
  data() {
    return {
      // 初始化组件的数据
      // controllerNum: "",
      // moduleId: "",
      // deviceName: "",
      swiperNum: 0,
      // 存储顶部和底部 Tab 项的数组
      tabsTop: [],
      tabsBottom: [],
      tabsTopValue: 0,
      tabsBottomValue: 0,
      // 控制新建多线盘对话框的显示状态
      showAddModal: false,
      // 新建多线盘表单的数据
      addForm: {
        tabName: "",
      },
      // 表单验证规则
      addRule: {
        tabName: [
          {
            required: true,
            message: `请输入多线盘序号`,
            trigger: "blur",
          },
        ],
      },
      addRule2: {
        tabName: [
          {
            required: true,
            message: `请输入总线盘序号`,
            trigger: "blur",
          },
        ],
      },
      videoW: 300,
      videoH: 300,
      videoList: [
        {
          videoUrl: "ezopen://open.ys7.com/G06344503/1.hd.live",
        },
      ],
      editTopState: false,
      // 搜索表单数据
      serchTopForm: {
        name: null,
        buildingId: null,
        partTypeCode: null,
      },
      serchBottomForm: {
        name: null,
        buildingId: null,
        partTypeCode: null,
      },
      // 系统和设备类型下拉选项
      systemForm: [],
      deviceTypeCode: [],
      addPointVisible: false,
      editBottomState: false,
      contentTabType: "0", //0主线盘 1多线盘
      pointShieldingVisible: false,
      operationsType: 1,
      controlContentTopTabObj: [],
      controlContentBottomTabObj: [],
      activeTabId: "",
      activeTabTopIndex: 0,
      activeTabBottomIndex: 0,
      hostStateObj: {},
      operationLogList: [],
      getDates: getDate,
      loading: false,
      noMoreData: false,
      scrollTimer: null,
      currentPage: 1,
      intervalNum: 0,
      intervalIndex: 0,
      ceshiShow: false,
      loginData: {},
    };
  },
  // 注册组件
  components: {
    VideoMonitor,
    PoliceLog,
    addpoint,
    pointShielding,
  },
  computed: {
    // 计算视频容器样式
    videoContainerStyle() {
      return {
        width: this.videoW + "px",
        height: this.videoH - 80 + "px",
      };
    },
    showLoadMore() {
      return !this.loading && !this.noMoreData;
    },
  },
  methods: {
    async getTopBottomTabList(diskType) {
      try {
        const response = await this.$Axios({
          url: `/mcbw/control_host_disks`,
          type: "get",
          obj: { fireControlHostId: this.moduleId, diskType: diskType },
        });
        return response;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    async postTopBottomTabList(diskType, name) {
      let commitData = {
        fireControlHostId: this.moduleId,
        diskType: diskType,
        orgId: this.orgId,
        name: name,
        sortNum: "1",
      };
      try {
        const response = await axios1({
          url: `/mcbw/control_host_disks`,
          type: "post",
          obj: commitData,
        });
        return response;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    async delTopBottomTabList(id) {
      try {
        const response = await this.$Axios({
          url: `/mcbw/control_host_disks/${id}`,
          type: "delete",
          obj: {},
        });
        return response;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    // 处理顶部 Tab 项移除事件
    handleTabTopRemove(index) {
      console.log("Removing tab at index:", index);
      console.log("Updated tabs:", this.tabsTop);
    },
    // 在移除顶部 Tab 项前的确认操作
    beforeTopRemove(index) {
      this.contentTabType = 1;
      return new Promise((resolve, reject) => {
        this.$Modal.confirm({
          title: "确认删除",
          content: "<p>确定要删除该项吗？</p>",
          onOk: () => {
            this.delTopBottomTabList(this.tabsTop[index].id).then((res) => {
              resolve(true);
              this.tabsTopValue = 0;
              this.activeTabTopIndex = 0;
              this.getTopBottomTabList(this.contentTabType).then((res) => {
                if (res.data.success) {
                  this[this.contentTabType == "1" ? "tabsTop" : "tabsBottom"] =
                    res.data.data;
                  if (res.data.data && res.data.data.length > 0) {
                    this.getTopBottomTabObj(this.contentTabType, 0).then(
                      (res) => {
                        this.controlContentTopTabObj = res.data.data;
                      }
                    ); //控制内容列表
                  }
                }
              });
            });
          },
          onCancel: () => {
            reject();
          },
        });
      });
    },
    // 处理增加 Tab 项的事件
    handleTabsAdd(type) {
      this.contentTabType = type;
      this.showAddModal = true;
      this.ceshiShow = !this.ceshiShow;
    },
    // 处理顶部 Tab 项切换事件
    tabTopChange(e) {
      this.activeTabTopIndex = parseInt(e);
      this.tabsTopValue = parseInt(e);
      this.serchTopForm = {
        name: null,
        buildingId: null,
        partTypeCode: null,
      };
      this.getTopBottomTabObj(1, e).then((res) => {
        this.controlContentTopTabObj = res.data.data;
      }); //控制内容列表
    },
    // 处理底部 Tab 项移除事件
    handleTabBottomRemove(index) {
      console.log("Removing tab at index:", index);
      console.log("Updated tabsBottom:", this.tabsBottom);
    },
    // 在移除底部 Tab 项前的确认操作
    beforeBottomRemove(index) {
      this.contentTabType = 0;
      return new Promise((resolve, reject) => {
        this.$Modal.confirm({
          title: "确认删除",
          content: "<p>确定要删除该项吗？</p>",
          onOk: () => {
            this.delTopBottomTabList(this.tabsBottom[index].id).then((res) => {
              resolve(true);
              this.tabsBottomValue = 0;
              this.activeTabBottomIndex = 0;
              this.getTopBottomTabList(this.contentTabType).then((res) => {
                if (res.data.success) {
                  this[this.contentTabType == "1" ? "tabsTop" : "tabsBottom"] =
                    res.data.data;
                  if (res.data.data && res.data.data.length > 0) {
                    this.getTopBottomTabObj(this.contentTabType, 0).then(
                      (res) => {
                        this.controlContentBottomTabObj = res.data.data;
                      }
                    ); //控制内容列表
                  }
                }
              });
            });
          },
          onCancel: () => {
            reject();
          },
        });
      });
    },
    // 处理底部 Tab 项切换事件
    tabBottomChange(e) {
      console.log(e);
      this.activeTabBottomIndex = parseInt(e);
      this.tabsBottomValue = parseInt(e);
      this.serchBottomForm = {
        name: null,
        buildingId: null,
        partTypeCode: null,
      };
      this.getTopBottomTabObj(0, e).then((res) => {
        this.controlContentBottomTabObj = res.data.data;
      }); //控制内容列表
    },
    // 取消新建多线盘对话框，并重置表单
    cancelAddModal() {
      this.$refs.addFormRef.resetFields();
      this.showAddModal = false;
      console.log(this.showAddModal);
    },
    // 提交新建多线盘对话框，添加新的 Tab 项
    submitAddModal() {
      this.$refs.addFormRef.validate((result) => {
        if (result) {
          this.postTopBottomTabList(
            this.contentTabType,
            this.addForm.tabName
          ).then((res) => {
            // this[this.contentTabType == 1 ? "tabsTop" : "tabsBottom"].push(
            //   this.addForm.tabName
            // );
            this.showAddModal = false;
            this.$refs.addFormRef.resetFields();
            this.getTopBottomTabList(this.contentTabType).then((res) => {
              this[this.contentTabType == "1" ? "tabsTop" : "tabsBottom"] =
                res.data.data;
            });
          });
        } else {
          this.$Message.error("表单验证失败!");
        }
      });
    },
    // 获取控制内容列表
    async getTopBottomTabObj(tabType, tabIndex) {
      try {
        let params = {
          currentPage: 1,
          pageSize: 500,
          orgId: this.orgId,
          controlHostDiskId:
            this[tabType == 1 ? "tabsTop" : "tabsBottom"][tabIndex].id,
          mainframeId: this.moduleId,
          name:
            tabType == 1 ? this.serchTopForm.name : this.serchBottomForm.name,
          buildingId:
            tabType == 1
              ? this.serchTopForm.buildingId
              : this.serchBottomForm.buildingId,
          partTypeCode:
            tabType == 1
              ? this.serchTopForm.partTypeCode
              : this.serchBottomForm.partTypeCode,
        };
        const response = await this.$Axios({
          url: `/mcbw/host_parts`,
          type: "get",
          obj: params,
        });
        return response;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    async putTopBottomTabObj(id, name) {
      console.log(id, name, "id, name");
      try {
        await this.$Axios({
          url: `/mcbw/host_parts`,
          type: "put",
          obj: { id: id, name: name },
        }).then((res) => {
          this.$Message.success(res.data.message);
        });
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    // 获取建筑物下拉选项
    async getSystemFormOption() {
      try {
        const response = await this.$Axios({
          url: `/mcbw/buildings`,
          type: "get",
          obj: { pageSize: 1000, currentPage: 1, orgId: this.orgId },
        });
        return response;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    // 获取设备类型下拉选项
    async getDeviceTypeCodeOption() {
      try {
        const response = await this.$Axios({
          url: `/mcbw/dictionary_datas/partTypeCode/data`,
          type: "get",
          obj: {
            pageSize: 1000,
            currentPage: 1,
            values:
              "53,66,48,54,59,29,56,26,60,61,62,64,65,70,24,79,80,72,124,125,126,127,130,131",
          },
        });
        return response;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    // 判断是否是最后一行
    isLastRow(index, totalItems, itemsPerRow) {
      const lastRowIndex = Math.ceil(totalItems / itemsPerRow) - 1;
      const currentRowIndex = Math.floor(index / itemsPerRow);
      return lastRowIndex === currentRowIndex;
    },
    // 顶部搜索相关方法
    getTopSearch() {
      this.getTopBottomTabObj(1, this.activeTabTopIndex).then((res) => {
        this.controlContentTopTabObj = res.data.data;
      }); //控制内容列表
    },
    // 删除变更相关方法
    async delChange(activeItem, controlType) {
      try {
        await this.$Axios({
          url: `/mcbw/host_parts/update_disk`,
          type: "put",
          obj: { mainframeId: this.moduleId, ids: activeItem.id },
        }).then((res) => {
          this.$Message.success(res.data.message);
          if (controlType == "1") {
            this.getTopBottomTabObj(1, this.activeTabTopIndex).then((res) => {
              this.controlContentTopTabObj = res.data.data;
            }); //控制内容列表
          } else {
            this.getTopBottomTabObj(0, this.activeTabBottomIndex).then(
              (res) => {
                this.controlContentBottomTabObj = res.data.data;
              }
            ); //控制内容列表
          }
        });
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    // 启动停止顶部变更相关方法 type 0 启动 1 停止
    async startStopTopChange(activeItem, type) {
      let _that = this;
      clearInterval(_that.intervalNum);
      try {
        await this.$Axios({
          url: `/mcbw/fire_control_hosts/control`,
          type: "post",
          obj: {
            targetType: 1,
            tid:
              this.controllerNum +
              "-" +
              activeItem.circuitNum +
              "-" +
              activeItem.bitNum +
              "-" +
              activeItem.partTypeCode,
            operate: "6",
            value: type,
            hostId: this.moduleId,
            pointId: activeItem.id,
            downValue:
              this.loginData.userName +
              "执行" +
              activeItem.name +
              (type == 1 ? "启动" : "停止") +
              "操作。",
          },
        }).then((res) => {
          this.$Message.success(res.data.message);
          this.getTopBottomTabObj(1, this.activeTabTopIndex).then((res) => {
            this.controlContentTopTabObj = res.data.data;
          }); //控制内容列表
          this.getTopBottomTabObj(0, this.activeTabBottomIndex).then((res) => {
            this.controlContentBottomTabObj = res.data.data;
          }); //控制内容列表
          this.refresh(false);
        });
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    // 添加点位变更相关方法
    addPointChange(type) {
      this.activeTabId =
        this[type == "1" ? "tabsTop" : "tabsBottom"][
          type == "1" ? this.activeTabTopIndex : this.activeTabBottomIndex
        ].id;
      this.addPointVisible = true;
    },
    // 更新添加点位状态
    addPointUpdate(obj) {
      this.addPointVisible = false;
      this.getTopBottomTabObj(1, this.activeTabTopIndex).then((res) => {
        this.controlContentTopTabObj = res.data.data;
      }); //控制内容列表
      this.getTopBottomTabObj(0, this.activeTabBottomIndex).then((res) => {
        this.controlContentBottomTabObj = res.data.data;
      }); //控制内容列表
    },
    // 更新点位屏蔽接触屏蔽状态
    pointShieldingUpdate(obj) {
      this.pointShieldingVisible = false;
    },
    // 底部搜索相关方法
    getbottomSearch() {
      this.getTopBottomTabObj(0, this.activeTabBottomIndex).then((res) => {
        this.controlContentBottomTabObj = res.data.data;
      }); //控制内容列表
    },
    // 主操作相关方法
    masterOperations(type) {
      this.operationsType = type;
      if (type == 6 || type == 7) {
        this.pointShieldingVisible = true;
      } else {
        // if (type == 4) {
        //   if (
        //     this.hostStateObj.sdo == 1 &&
        //     this.hostStateObj.zdo == 0 &&
        //     this.hostStateObj.ps == 0
        //   ) {
        //     this.$Message.error("操作异常");
        //     return;
        //   }
        // } else if (type == 5) {
        //   if (
        //     this.hostStateObj.sdo == 0 &&
        //     this.hostStateObj.zdo == 1 &&
        //     this.hostStateObj.ps == 0
        //   ) {
        //     this.$Message.error("操作异常");
        //     return;
        //   }
        // }
        this.hostOperations(type).then((res) => {
          if (res.data.success) {
            this.$Message.success(res.data.message);
            this.refresh(false);
          } else {
            this.$Message.error(res.data.message);
          }
        });
      }
    },
    // 主机操作
    async hostOperations(type) {
      let content = "";
      let state = "";
      switch (type) {
        case 1:
          content = "消音";
          state = 1;
          break;
        case 2:
          content = "复位";
          state = 1;
          break;
        case 3:
          content = "自检";
          state = 1;
          break;
        case 4:
          // content = this.hostStateObj.sdo == 1 ? "手动禁止" : "手动允许";
          // state = this.hostStateObj.sdo == 1 ? 0 : 1;
          content = "手动";
          state = 1;
          break;
        case 5:
          // content = this.hostStateObj.zdo == 1 ? "自动禁止" : "自动允许";
          // state = this.hostStateObj.zdo == 1 ? 0 : 1;
          content = "自动";
          state = 1;
          break;
        case 8:
          content = this.hostStateObj.ps == 1 ? "喷洒禁止" : "喷洒允许";
          state = this.hostStateObj.ps == 1 ? 0 : 1;
          break;
      }
      try {
        const response = await this.$Axios({
          url: `/mcbw/fire_control_hosts/control`,
          type: "post",
          obj: {
            targetType: 2,
            tid: this.controllerNum + "-00-000000-00",
            operate: type,
            value: state,
            hostId: this.moduleId,
            downValue:
              this.loginData.userName + "执行主机" + content + "操作。",
          },
        });
        return response;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    async getHostState() {
      try {
        await this.$Axios({
          url: `/mcbw/fire_control_hosts/work_state/${this.moduleId}`,
          type: "get",
          obj: {},
        }).then((res) => {
          this.hostStateObj = res.data.data;
        });
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    // 操作日志滚动事件
    handleScroll() {
      if (this.scrollTimer) return;

      this.scrollTimer = setTimeout(() => {
        const operationLogListRef = this.$refs.operationLogListRef;
        if (
          operationLogListRef.scrollTop + operationLogListRef.clientHeight >=
            operationLogListRef.scrollHeight - 10 &&
          this.showLoadMore
        ) {
          this.getOperationLog();
        }
        this.scrollTimer = null;
      }, 200);
    },
    // 操作日志
    async getOperationLog() {
      if (!this.showLoadMore) return;
      this.loading = true;
      try {
        const params = {
          orgId: this.orgId,
          partId: this.moduleId,
          pageSize: 10,
          currentPage: this.currentPage,
        };
        const response = await this.$Axios({
          url: `/mcbw/fire_control_hosts/down_command_record`,
          type: "get",
          obj: params,
        });

        if (response.data.data.length > 0) {
          this.operationLogList = [
            ...this.operationLogList,
            ...response.data.data,
          ];
          this.currentPage++;
        } else {
          this.noMoreData = true;
        }
      } catch (err) {
        console.error("Failed to fetch police log list:", err);
      } finally {
        this.loading = false;
      }
    },
    closeModel() {
      this.$emit("closeUpDate", false);
    },
    refresh(timingInterval = true) {
      let _that = this;
      if (!timingInterval) {
        if (_that.intervalNum) {
          clearInterval(_that.intervalNum);
          _that.intervalIndex = 0;
        }
      }
      _that.intervalNum = setInterval(
        () => {
          _that.intervalIndex++;
          _that.getTopBottomTabObj(1, _that.activeTabTopIndex).then((res) => {
            _that.controlContentTopTabObj = res.data.data;
          }); //控制内容列表
          _that
            .getTopBottomTabObj(0, _that.activeTabBottomIndex)
            .then((res) => {
              _that.controlContentBottomTabObj = res.data.data;
            }); //控制内容列表
          _that.getHostState();
          if (_that.intervalIndex == 3 && !timingInterval) {
            _that.loading = false;
            _that.noMoreData = false;
            _that.currentPage = 1;
            _that.operationLogList = [];
            _that.getOperationLog();
          }
          // if (timingInterval) {
          //   setTimeout(() => {
          //     _that.intervalIndex = 0;
          //   }, 0);
          // }
          if (_that.intervalIndex > 2 && !timingInterval) {
            clearInterval(_that.intervalNum);
            _that.intervalIndex = 0;
            setTimeout(() => {
              _that.refresh(true);
            }, 0);
          }
        },
        timingInterval ? 5000 * 3 : 5000
      );
    },
    singleRefresh() {
      let _that = this;
      // if (_that.intervalNum) {
      //   clearInterval(_that.intervalNum);
      // }
      _that.intervalIndex = 1;
      _that.getTopBottomTabObj(1, _that.activeTabTopIndex).then((res) => {
        _that.controlContentTopTabObj = res.data.data;
      }); //控制内容列表
      _that.getTopBottomTabObj(0, _that.activeTabBottomIndex).then((res) => {
        _that.controlContentBottomTabObj = res.data.data;
      }); //控制内容列表
      _that.getHostState();
      _that.loading = false;
      _that.noMoreData = false;
      _that.currentPage = 1;
      _that.operationLogList = [];
      _that.getOperationLog();
      setTimeout(() => {
        _that.intervalIndex = 0;
      });
    },
  },
  // 组件挂载后执行的钩子函数
  mounted() {
    this.$nextTick(() => {
      this.loginData = JSON.parse(window.localStorage.getItem("loginData"));
      const controlLeft = this.$refs.controlLeft;
      if (controlLeft) {
        this.videoW = controlLeft.getBoundingClientRect().width;
        this.videoH = controlLeft.getBoundingClientRect().height;
        console.log("Width of controlLeft:", this.videoW, this.videoH);
      } else {
        console.log("Element not found");
      }
      this.getTopBottomTabList("1").then((res) => {
        this.tabsTop = res.data.data;
        this.getTopBottomTabObj(1, 0).then((res) => {
          this.controlContentTopTabObj = res.data.data;
        }); //控制内容列表
      }); //多线盘
      this.getTopBottomTabList("0").then((res) => {
        this.tabsBottom = res.data.data;
        this.getTopBottomTabObj(0, 0).then((res) => {
          this.controlContentBottomTabObj = res.data.data;
        }); //控制内容列表
      }); //主线盘
      this.getSystemFormOption().then((res) => {
        this.systemForm = res.data.data;
      }); //系统
      this.getDeviceTypeCodeOption().then((res) => {
        this.deviceTypeCode = res.data.data;
      }); //设备类型
      this.getHostState().then((res) => {
        console.log(res, "res");
      });
      this.getOperationLog();
      this.$refs.operationLogListRef.addEventListener(
        "scroll",
        this.handleScroll
      );
      this.refresh();
    });
  },
  // 组件销毁前执行的钩子函数
  beforeDestroy() {
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
    }
    if (this.intervalNum) {
      clearInterval(this.intervalNum);
      this.intervalNum = 0;
      this.intervalIndex = 0;
    }
    this.$refs.operationLogListRef.removeEventListener(
      "scroll",
      this.handleScroll
    );
  },
};
</script>
<style scoped lang="less">
.nav-top {
  padding-bottom: 10px;
  .txt {
    font-size: 26px;
    font-weight: normal;
    line-height: 24px;
    color: #fff;
    font-weight: 600;
    i {
      font-size: 26px;
      color: red;
    }
  }
  .close-btn {
    color: #74d9ff;
    cursor: pointer;
  }
}
.title {
  font-size: 20px;
  font-weight: bold;
  color: #fff !important;
}
.sub-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff !important;
}
.control-left {
  height: 100%;
  width: 29%;
  .control-left-top {
    // height: 280px;
    height: ~"calc(50vh - 90px)";
    background: #07132b;
    -webkit-box-shadow: 0 2px 4px 0 #d1d1d180, inset 0 1px 15px 3px #1b447b;
    box-shadow: 0 2px 4px 0 #d1d1d180, inset 0 1px 15px 3px #1b447b;
    border-radius: 12px;
    padding: 10px;
    margin-bottom: 10px;
    .control-left-top-title {
      margin-bottom: 10px;
    }
  }
  .control-left-bottom {
    // height: ~"calc(100vh - 460px)";
    height: ~"calc(50vh - 90px)";
    background: #07132b;
    -webkit-box-shadow: 0 2px 4px 0 #d1d1d180, inset 0 1px 15px 3px #1b447b;
    box-shadow: 0 2px 4px 0 #d1d1d180, inset 0 1px 15px 3px #1b447b;
    border-radius: 12px;
    padding: 10px;
    .control-left-bottom-title {
      margin-bottom: 10px;
      & > ul {
        list-style: none;
        li {
          display: inline-block;
          margin-left: 10px;
          cursor: pointer;
          border-radius: 4px;
          padding: 3px 10px;
          &.active {
            color: #fff;
            background-color: #1890ff;
            border-color: #1890ff;
          }
          &.active-c {
            background-color: #ff0c0c;
            box-shadow: 0px 0px 8px 0px #ff0c0c;
          }
        }
      }
    }
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.control-content {
  width: 50%;
  // height: ~"calc(100vh - 170px)";
  .control-content-top {
    height: ~"calc(50vh - 90px)";
    background: #07132b;
    -webkit-box-shadow: 0 2px 4px 0 #d1d1d180, inset 0 1px 15px 3px #1b447b;
    box-shadow: 0 2px 4px 0 #d1d1d180, inset 0 1px 15px 3px #1b447b;
    border-radius: 12px;
    padding: 10px;
    .control-content-title {
      margin-bottom: 10px;
      .sub-tit {
        margin-left: 10px;
      }
    }
    .control-content-list {
      margin-top: 10px;
      height: 220px;
      overflow-y: scroll;
      /deep/ .ivu-poptip,
      .ivu-poptip-rel {
        width: auto;
      }

      & > ul {
        list-style: none;
        li {
          height: 90px;
          border-radius: 12px;
          border: 1px solid rgba(116, 217, 255, 0.5);
          padding: 10px;
          box-sizing: border-box;
          width: 19%;
          margin-right: 1.25%;
          margin-bottom: 10px;
          &:nth-child(5n) {
            margin-right: 0;
          }
          h3 {
            font-size: 14px;
            font-weight: 600;
            color: #74d9ff;
            > span,
            > input {
              width: 85%;
              display: inline-block;
              color: #74d9ff;
            }
            > input {
              height: 27px;
              background-color: rgba(255, 255, 255, 0.2);
              border: none;
              border-radius: 4px;
            }
            .ivu-poptip {
              float: right;
              i {
                font-size: 16px;
                color: red;
                cursor: pointer;
              }
            }
          }
          .control-content-list-state {
            font-size: 12px;
            margin-bottom: 5px;
            color: #74d9ff;
            i {
              width: 10px;
              height: 10px;
              border-radius: 50%;
              display: inline-block;
              margin-right: 10px;
              background: linear-gradient(
                  0deg,
                  rgba(0, 0, 0, 0.001),
                  rgba(0, 0, 0, 0.001)
                ),
                #adadad;
              &.active {
                background: linear-gradient(
                    0deg,
                    rgba(0, 0, 0, 0.001),
                    rgba(0, 0, 0, 0.001)
                  ),
                  #ff0c0c;
                box-shadow: 0px 0px 8px 0px #ff0c0c;
                animation: fadeIn 0.5s infinite ease-in-out;
              }
              &.active-c {
                background-color: #ff0c0c;
                box-shadow: 0px 0px 8px 0px #ff0c0c;
              }
            }
          }
          .control-content-list-btn {
            button {
              height: 22px;
              padding: 0px 5px;
              margin-left: 10px;
              background-color: #0256ff;
            }
          }
          &.control-content-list-add {
            text-align: center;
            padding-top: 20px;
            font-weight: 600;
            color: #74d9ff;
            cursor: pointer;
            i {
              font-size: 30px;
              font-weight: normal;
            }
          }
        }
      }
    }
  }
  .control-content-bottom {
    margin-top: 10px;
    .control-content-list {
      & > ul {
        li {
          .control-content-list-state-btn {
            .control-content-list-state {
              width: 50%;
              > div {
                &:first-child {
                  margin-bottom: 10px;
                }
              }
            }
            .control-content-list-btn {
              button {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                text-align: center;
                line-height: 40px;
              }
            }
          }
        }
      }
    }
  }
}
.control-right {
  width: 19%;
  // height: ~"calc(100vh - 170px)";
  .control-right-top {
    height: ~"calc(50vh - 90px)";
    background: #07132b;
    -webkit-box-shadow: 0 2px 4px 0 #d1d1d180, inset 0 1px 15px 3px #1b447b;
    box-shadow: 0 2px 4px 0 #d1d1d180, inset 0 1px 15px 3px #1b447b;
    border-radius: 12px;
    padding: 10px;
    .control-right-top-top {
      background-color: rgba(243, 243, 243, 0.2);
      border-radius: 8px;
      padding: 20px;
      margin-top: 10px;
      padding-bottom: 7px;
      .control-right-top-item {
        width: 25%;
        margin-bottom: 12px;
        > span {
          font-size: 14px;
          color: #74d9ff;
          > i {
            display: inline-block;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            vertical-align: text-bottom;
            margin-right: 5px;
            background-color: #adadad;
          }
          .color-red {
            background-color: #ff0c0c;
            box-shadow: 0px 0px 8px 0px #ff4d4f;
          }
          .color-orange {
            background-color: #faad14;
            box-shadow: 0px 0px 8px 0px #faad14;
          }
          .color-yellow {
            background-color: #f8c51c;
            box-shadow: 0px 0px 8px 0px #f8c51c;
          }
          .color-green {
            background-color: #1fd107;
            box-shadow: 0px 0px 8px 0px #1fd107;
          }
        }
      }
    }
    .control-right-top-bottom {
      .control-right-top-bottom-title {
        margin: 10px 0;
      }
      .control-right-top-button {
        margin-bottom: 10px;
        button {
          line-height: 20px;
          font-size: 14px;
          &.ivu-btn-primary {
            color: #fff;
            background-color: #2d8cf0;
            border-color: #2d8cf0;
          }
          i {
            margin-right: 5px;
            vertical-align: bottom;
          }
        }
      }
    }
  }
  .control-right-bottom {
    height: ~"calc(50vh - 90px)";
    background: #07132b;
    -webkit-box-shadow: 0 2px 4px 0 #d1d1d180, inset 0 1px 15px 3px #1b447b;
    box-shadow: 0 2px 4px 0 #d1d1d180, inset 0 1px 15px 3px #1b447b;
    border-radius: 12px;
    padding: 10px;
    margin-top: 10px;
    .control-right-bottom-content {
      height: ~"calc(50vh - 135px)";
      overflow-y: scroll;
      & > ul {
        list-style: none;
        li {
          padding: 10px;
          background-color: rgba(189, 232, 249, 0.2);
          box-sizing: border-box;
          border: 1px solid rgba(226, 239, 254, 0.5);
          margin-top: 10px;
          border-radius: 12px;
          p {
            font-size: 14px;
            font-weight: normal;
            line-height: 22px;
            color: #c9f0ff;
          }
          h4 {
            font-size: 14px;
            font-weight: normal;
            line-height: 25px;
            color: #74d9ff;
          }
        }
      }
    }
  }
  .no-more-data {
    text-align: center;
    padding: 10px;
    color: #999;
  }
}
/deep/ .show-add-tab {
  .ivu-modal-content {
    background-color: #041936;
    box-shadow: inset 0px 0px 30px 0px rgba(62, 117, 190, 0.5);
    .ivu-modal-header {
      border-bottom: 1px solid #979797;
      .ivu-modal-header-inner {
        color: #eef2f4;
      }
    }
    .ivu-form-item-label {
      color: #74d9ff;
    }
    .ivu-input {
      background: rgba(255, 255, 255, 0.2);
      box-sizing: border-box;
      border: 1px solid #596c87;
      color: #74d9ff;
    }
  }
  .ivu-modal-body {
    padding-top: 15px;
    .show-table-header {
      border-left: 2px solid #02e7e7;
      margin-left: 15px;
      padding-left: 10px;
      .table-header-desc {
        font-size: 18px;
        color: #02e7e7;
      }
      /deep/ .close-btn {
        float: right;
        margin-right: 20px;
        border: 1px solid #08f4f7;
        color: #08f4f7;
        width: 56px;
        height: 28px;
        line-height: 28px;
        cursor: pointer;
        outline: none;
        border-color: rgba(8, 244, 247, 0.3);
        background-color: hsla(0, 0%, 100%, 0.1);
      }
    }
  }
  .ivu-modal-footer {
    border-color: #979797;
  }
}
/deep/ .ivu-tabs-bar {
  border-color: rgba(116, 217, 255, 0.5) !important;
  .ivu-tabs-tab {
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .ivu-tabs-tab-active {
    background-color: rgba(0, 0, 0, 0) !important;
    color: #74d9ff !important;
  }
  .ivu-tabs-tab {
    border-color: rgba(116, 217, 255, 0.5) !important;
  }
  .ivu-tabs-close:hover {
    color: #74d9ff !important;
  }
}
/deep/ .ivu-poptip-inner {
  background-color: #041b3b;
}
/deep/ .ivu-poptip-popper .ivu-poptip-arrow:after {
  border-top-color: #041b3b;
}
/deep/ .ivu-poptip-popper .ivu-poptip-arrow {
  border-top-color: #041b3b;
}
/deep/ .ivu-btn-text {
  background-color: #041b3b;
  border: 1px solid #dcdfe6;
  color: #ffffff;
}
/deep/ .ivu-btn-primary {
  background-color: #3662ec;
  border: 1px solid #3662ec;
  color: #ffffff;
}
/deep/ .ivu-poptip-body-message {
  color: #74d9ff;
}
</style>



// WEBPACK FOOTER //
// src/components/remote-control/remote-control.vue